var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m6.343 16.242 4.243-4.243-4.243-4.243 1.414-1.414L12 10.585l4.243-4.243 1.414 1.414L13.414 12l4.243 4.243-1.414 1.414L12 13.413l-4.243 4.243-1.414-1.414Z",
    fill: "currentColor"
  })));
};
export default SvgClose;